export default "__VITE_ASSET__OiCdTCg9__"